import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import TransactionMenuListView from './views/TransactionMenuListView';

export const transactionMenuRoutes: RouteObject[] = [
    {
        path: '/admin/customize-transaction-menus',
        element: <TransactionMenuListView />,
        errorElement: <ErrorBoundary />
    }
];
